module.exports = __webpack_public_path__ + "media/images/folder--e58158c3.png";